import { Actions } from '@components/shared/Actions'
import { EditIcon } from '@assets/svgs/EditIcon'
import { DeleteIcon } from '@assets/svgs/DeleteIcon'

import type { NotFeedResponseProps } from './mocks/notFeedMock'
import type { ColumnDefProps } from '@components/shared/Table/types'

interface ParseNotFeedProps {
  data: NotFeedResponseProps[]
  onEdit: (data: NotFeedResponseProps) => void
  onDelete: (data: NotFeedResponseProps) => void
}

export const parseNotFeedGrid = ({ data, onEdit, onDelete }: ParseNotFeedProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'category',
      columnName: 'Categoria',
      align: 'center',
      value: item.category,
      sortable: true
    },
    {
      id: 'description',
      columnName: 'Descrição',
      align: 'center',
      value: item.description,
      sortable: true
    },
    {
      id: 'unit',
      columnName: 'Unidade',
      align: 'center',
      value: item.unit,
      sortable: true
    },
    {
      id: 'quantity',
      columnName: 'Quantidade',
      align: 'center',
      value: item.quantity,
      sortable: true
    },
    {
      id: 'unitValue',
      columnName: 'Valor Unitário',
      align: 'center',
      value: item.unitValue,
      currency: true,
      sortable: true
    },
    {
      id: 'totalValue',
      columnName: 'Valor Total',
      align: 'center',
      value: item.totalValue,
      currency: true,
      sortable: true
    },
    {
      id: 'action',
      columnName: 'Ações',
      align: 'center',
      minWidth: '5rem',
      maxWidth: '5rem',
      stickyPosition: 'right',
      value: (
        <Actions
          actions={[
            { label: 'Editar', icon: <EditIcon />, onClick: () => onEdit(item) },
            { label: 'Editar', icon: <DeleteIcon />, onClick: () => onDelete(item) }
          ]}
        />
      )
    }
  ])

  return parsedData
}
